import { render, staticRenderFns } from "./AsignacionMunicion.vue?vue&type=template&id=680327f5&scoped=true"
import script from "./AsignacionMunicion.vue?vue&type=script&lang=js"
export * from "./AsignacionMunicion.vue?vue&type=script&lang=js"
import style0 from "./AsignacionMunicion.vue?vue&type=style&index=0&id=680327f5&prod&lang=css"
import style1 from "./AsignacionMunicion.vue?vue&type=style&index=1&id=680327f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680327f5",
  null
  
)

export default component.exports